import React from "react";
import _ from "lodash";
import moment from "moment";
import { ButtonSizeOptions, MaterialIcon, LabelDollarFormatted } from "@loanbossinc/component-library";

import {
  LevelWrapper,
  NameWrapper,
  WideStyledPrimaryButton,
  InfoWrapper,
  Wrapper,
  CalculationWrapper,
  NameDateWrapper,
  DataAsOfDate,
  UploadDate,
  StyledLockedSwitch,
  LeftCalculationSection,
  PreviewResult,
  SwitchWrapper,
  AnnualizedText,
  CellsAmount
} from "./sourceFileFieldStyles";

export const SourceFileListItem = props => {
  const {
    sourceFileId,
    sourceName,
    summary,
    typeName,
    asOfDate,
    updatedAtDate,
    isAnnualized,
    calculatedValue,
    amountOfCellsSelected,
    onAnnualizeSwitch,
    isEditing,
    isAdding,
    selectedSourceFile,
    onSelectFileOrSelectRange
  } = props;

  const onClickSelectOrEditRange = () => {
    const isRangeSelect = isAdding && !selectedSourceFile;
    onSelectFileOrSelectRange(sourceFileId, !isRangeSelect);
  };

  return (
    <Wrapper>
      <InfoWrapper>
        <MaterialIcon iconName="description" style={{ color: "#5f6368" }} />
        <NameDateWrapper>
          <NameWrapper>{_.startCase(`${sourceName} ${typeName}`)}</NameWrapper>
          <DataAsOfDate>{`Data As Of ${moment.utc(asOfDate).format("MMMM DD, YYYY")}`}</DataAsOfDate>
          <UploadDate>{`Last Updated ${moment.utc(updatedAtDate).format("MMMM DD, YYYY")}`}</UploadDate>
          <LevelWrapper>{summary}</LevelWrapper>
        </NameDateWrapper>
        <WideStyledPrimaryButton
          onClick={onClickSelectOrEditRange}
          size={ButtonSizeOptions.sm}
          label={selectedSourceFile || isEditing ? "Edit range selector" : "Select"}
        />
      </InfoWrapper>
      {(isEditing || (isAdding && selectedSourceFile)) && (
        <CalculationWrapper>
          <LeftCalculationSection>
            <SwitchWrapper>
              <StyledLockedSwitch value={isAnnualized} onChange={onAnnualizeSwitch} />
              <AnnualizedText>{`These calculations are${!isAnnualized ? " not" : ""} annualized.`}</AnnualizedText>
            </SwitchWrapper>
            <CellsAmount>
              {`${amountOfCellsSelected} cells selected`}
              {" "}
            </CellsAmount>
          </LeftCalculationSection>
          <PreviewResult>
            <LabelDollarFormatted decimals={2} value={calculatedValue} />
          </PreviewResult>
        </CalculationWrapper>
      )}
    </Wrapper>
  );
};

export default SourceFileListItem;
